import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { ProfileApi } from '@shared/api/rest';
import type { UsersFeaturesResponse } from '@shared/api/rest/users';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getFeaturesEffect = createEffect((params?: IQueryParams) => ProfileApi.getProfileFeatures(params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<UsersFeaturesResponse | null>(null)
  .on(getFeaturesEffect.done, (current, data) => data.result ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getFeaturesEffect.pending, (_, data) => data)
  .on(getFeaturesEffect.fail, () => false)
  .on(getFeaturesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getFeaturesEffect, () => null)
  .on(getFeaturesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getFeaturesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $profileFeatureStore = {
  events: {
    get: ApiUtils.wrapperApi(getFeaturesEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
